import { render } from "./InitLoader.vue?vue&type=template&id=505b581e&scoped=true"
import script from "./InitLoader.vue?vue&type=script&lang=js"
export * from "./InitLoader.vue?vue&type=script&lang=js"

import "./InitLoader.vue?vue&type=style&index=0&id=505b581e&scoped=true&lang=css"

import exportComponent from "C:\\0_PROJECTS\\EcoSim\\Csongrad\\sar_es_tuz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505b581e"]])

export default __exports__